// Player-facing text comes from shared/data/copy.json (IMPLEMENTATION §3 M1). `{name}` placeholders are
// filled here; a missing value keeps the placeholder visible instead of printing "undefined". Lookups use
// own keys only, so `{constructor}` or `unlock.toString` never reach Object.prototype.
import type { CopyData } from '../data/schema.ts';

export type CopyVars = Readonly<Record<string, string | number>>;

export function fillCopy(template: string, vars: CopyVars = {}): string {
  return template.replace(/\{([A-Za-z0-9_]+)\}/g, (m, k: string) =>
    Object.hasOwn(vars, k) ? String(vars[k]) : m,
  );
}

/** The raw template of a `section.key` reference, or null when it does not exist. */
export function copyRaw(copy: CopyData, ref: string): string | null {
  const dot = ref.indexOf('.');
  const sections = copy as unknown as Record<string, unknown>;
  const name = ref.slice(0, dot);
  const key = ref.slice(dot + 1);
  const section = dot > 0 && Object.hasOwn(sections, name) ? sections[name] : undefined;
  const t =
    section !== null && typeof section === 'object' && Object.hasOwn(section, key)
      ? (section as Record<string, unknown>)[key]
      : undefined;
  return typeof t === 'string' ? t : null;
}

/** Text for a `section.key` reference (as used by unlocks.json and stalls.json); `[ref]` when missing. */
export function copyText(copy: CopyData, ref: string, vars?: CopyVars): string {
  const t = copyRaw(copy, ref);
  return t !== null ? fillCopy(t, vars) : `[${ref}]`;
}
